import axios from 'axios';

const BASE_URL = '/api/preguntas-frecuentes';
// Usamos el proxy (/api/preguntas-frecuentes -> backend)

export const preguntasFrecuentesService = {
    getPreguntasFrecuentes: async (empresaId, codigoProyecto) => {
        try {
            // El backend controller espera 'proyectoId' en query string
            const response = await axios.get(`${BASE_URL}`, {
                params: { proyectoId: codigoProyecto }
            });
            return response.data;
        } catch (error) {
            console.error('Error fetching FAQs:', error);
            throw error;
        }
    }
};
